<template>
  <div class="row vh-100">
    <div class="col-5" style="border-right: 1px solid #e0e0e0">
      <!-- <a-tabs :activeKey="activeKey"> -->
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Summary">
             
          <a-descriptions title="Transfer In Details" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Transfer ID" span="3">{{ this.transferInData.id }}</a-descriptions-item>
            <a-descriptions-item label="Origin Site" span="3">{{ this.transferInData.transferOriginSiteName.name }}</a-descriptions-item>
            <a-descriptions-item label="Status" span="3">
              <a-tag v-if="this.transferInData.transferStatus.name == 'Received'" color="#87d068">{{ this.transferInData.transferStatus.name.toUpperCase() }}</a-tag>
              <a-tag v-else color="#ff9d5c">{{ this.transferInData.transferStatus.name.toUpperCase() }}</a-tag>
            </a-descriptions-item>
             <a-descriptions-item label="Created By" span="3">{{ this.transferInData.createdBy.name }}</a-descriptions-item>
          </a-descriptions>

          <br/>

          <a-descriptions title="Card Count Summary" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Total Quantity" span="6">{{ this.transferInData.cards.length }}</a-descriptions-item>
            <a-descriptions-item label="Received" span="6">{{ this.cardListGrouped["Received"] ? this.cardListGrouped["Received"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit from Supplier" span="6">{{ this.cardListGrouped["Ordered"] ? this.cardListGrouped["Ordered"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit to Branch" span="6">{{ this.cardListGrouped["In-Transit"] ? this.cardListGrouped["In-Transit"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Activated" span="6">{{ this.cardListGrouped["Activated"] ? this.cardListGrouped["Activated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Used" span="6">{{ this.cardListGrouped["Assigned"] ? this.cardListGrouped["Assigned"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Deactivated" span="6">{{ this.cardListGrouped["Deactivated"] ? this.cardListGrouped["Deactivated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Rejected" span="6">{{ this.cardListGrouped["Rejected"] ? this.cardListGrouped["Rejected"].length : 0 }}</a-descriptions-item>
          </a-descriptions>

        </a-tab-pane>
       
        <a-tab-pane key="2" tab="For Receive" force-render v-if="transferInData.transferStatus.status_code == 'TRANSFER_INTRANSIT'">
          <a-table size="small"
            class="ant-table-striped"
            :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
            :dataSource="cardListGrouped['In-Transit'] ? cardListGrouped['In-Transit'] : []"
            :columns="cardDisplayColumns"
          />
        </a-tab-pane>

      </a-tabs>
    </div>

    <div class="col-7" v-if="transferInData.transferStatus.status_code == 'TRANSFER_INTRANSIT'">
      <h6 class="heading-small text-muted mb-4 text-truncate">
        <span v-if="transferInData.transferStatus.name == 'Received'"
          >View Transfer In</span
        >
        <span v-else>Receive Transfer In</span>
      </h6>

      <form id="form-proper" @submit.prevent="noop">
        <div class="py-2">
          <div class="row mb-3">
            <div class="col">
              <a-radio-group v-model="receiveBy" @change="onChange">
                <a-radio
                  v-for="option in receivingOptions"
                  :style="radioStyle"
                  :key="option.key"
                  :value="option.key"
                >
                  {{ option.value }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col">
              <base-input label="From">
                <a-input v-model="transferCardNumberFrom" disabled />
              </base-input>
            </div>
            <div class="col">
              <base-input label="To">
                <a-input v-model="transferCardNumberTo" disabled />
              </base-input>
            </div>
          </div> -->

          <div class="row" v-if="receiveBy == 'card_number'">
            <div
              class="col"
              v-if="transferInData.transferStatus.name != 'Received'"
            >
              <base-input label="Enter Card Number" required>
                <a-input v-model="cardNumber" @keypress.enter="addData()" />
              </base-input>
            </div>
          </div>

          <div class="row" v-if="receiveBy == 'range'">
            <div
              class="col"
              v-if="transferInData.transferStatus.name != 'Received'"
            >
              <base-input label="From" required>
                <a-input v-model="cardNumberFrom" />
              </base-input>
            </div>
            <div
              class="col"
              v-if="transferInData.transferStatus.name != 'Received'"
            >
              <base-input label="To" required>
                <a-input v-model="cardNumberTo" />
              </base-input>
            </div>
          </div>

          <div class="row" v-if="receiveBy != 'batch'">
            <div
              class="col"
              v-if="transferInData.transferStatus.name != 'Received'"
            >
              <b-button
                size="sm"
                class="float-md-right success"
                @click.prevent="addData"
              >
                Add
              </b-button>
            </div>
          </div>

          <br /><br />

          <div class="row">
            <div class="col">
              <a-table size="small"
                class="ant-table-striped"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
                v-if="receiveBy == 'card_number'"
                :dataSource="cardsFull"
                :columns="cardDisplayColumns"
              />
              <a-table size="small"
                class="ant-table-striped"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
                v-if="receiveBy == 'range'"
                :dataSource="cardRange"
                :columns="cardRangeColumns"
              />
            </div>
          </div>
        </div>
        <div
          style="
            z-index: 999;
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          "
        >
          <div class="container mx-0 px-0">
            <div class="row">
              <div class="col-auto mr-auto">
                <b-button
                  size="sm"
                  class="float-md-left"
                  style="margin-left: 8px"
                  @click.prevent="closeDrawer"
                >
                  Cancel
                </b-button>
              </div>
              <div class="col-auto">
                <template>
                  <a-spin :spinning="formSubmitting">
                    <div
                      v-if="
                        transferInData.transferStatus.status_code ==
                        'TRANSFER_INTRANSIT'
                      "
                    >
                      <!-- <b-button
                        v-if="receiveBy == 'batch'"
                        size="sm"
                        variant="primary"
                        @click.prevent="receiveCards"
                        :disabled="transferInData == null"
                      >
                        Receive & Post
                      </b-button> -->
                      <div class="d-flex flex-row bd-highlight mb-3">
                        <div class="px-1 ">
                          <b-button
                              size="sm"
                              @click.prevent="receiveCheck"
                              class="btn btn-warning btn-sm w-100" style="background-color: rgb(255, 157, 92) !important;"
                              :disabled="transferInData == null"
                          >
                            Receive
                          </b-button>
                        </div>
                        <div class="px-1 ">
                          <a-popconfirm v-if="receiveBy == 'batch'"
                                        title="This will change status of all unreceived cards to Rejected. Are you sure you want to proceed posting this transfer?"
                                        @confirm="() => postReceive()">
                            <a style="color: white;" class="btn btn-sm btn-primary">Post</a>
                          </a-popconfirm>
                        </div>
                      </div>

                    </div>
                  </a-spin>
                </template>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-7" v-if="transferInData.transferStatus.status_code == 'TRANSFER_RECEIVE'">

        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="Card List">
            <a-table 
              class="ant-table-striped"
              size="small"
              :columns="cardDisplayColumnsFull"
              :data-source="transferInData.fullCardDetails"
              :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
            />
          </a-tab-pane>
        </a-tabs>
        <br>
        
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '@/controllers/secureStorage';

export default {
  name: 'TransferInForm',
  props: {
    transferInData: Object,
    viewMode: Boolean,
  },
  data() {
    return {
      cardListGrouped: {},
      cardsFull: [],
      cardRange: [],
      formSubmitting: false,
      receiveBy: 'batch',
      cardDisplayColumnsFull: [
        { title: 'Card Type', key: 'card_type_name', dataIndex: 'card_type_name',},
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
        { title: 'Status', key: 'card_status_name', dataIndex: 'card_status_name' },
      ],
      cardDisplayColumns: [
        { title: 'Card Type', key: 'card_type_name', dataIndex: 'card_type_name',},
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
      ],
      cardRangeColumns: [
        { title: 'From', key: 'from', dataIndex: 'from' },
        { title: 'To', key: 'to', dataIndex: 'to' },
        { title: 'Valid Card Count', key: 'count', dataIndex: 'count' },
      ],
      receivingOptions: [
        {
          key: 'batch',
          value: 'Batch',
        },
        {
          key: 'card_number',
          value: 'Card Number',
        },
        {
          key: 'range',
          value: 'Card Series Range (Serial)',
        },
      ],

      formData: {
        // destination_site_id: null,
        membership_program_id: null,
        membership_level_id: null,
        card_type_id: null,
      },

      cards: [],
      cardNumberFrom: null,
      cardNumberTo: null,
      cardNumber: null,
      transferCardNumberFrom: null,
      transferCardNumberTo: null,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
    };
  },
  methods: {
    noop() {
      console.log('Prevent');
    },

    addData() {
      if (this.receiveBy == 'card_number') {
        this.validateCards(this.cardNumber, this.transferInData.id);
      } else if (this.receiveBy == 'range') {
        this.validateRange(this.cardNumberFrom, this.cardNumberTo);
      }
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data;
    },

    async receiveCheck(){
      if(this.receiveBy == 'batch'){
        await this.receiveCards()
      }else{
        await this.partialReceiveCards()
      }
    },

    async postReceive(){
      this.formSubmitting = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/transfer_in/' +
          this.transferInData.id +
          '/post?origin_site_id=' +
          secureStorage.getItem('currentSiteId')
      );

      if (response.id) {
        this.closeDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Transfer has been posted.',
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Something went wrong. Please try again.',
          placement: 'topLeft',
        });
      }

      this.formSubmitting = false;
      this.closeDrawer;
    },

    async receiveCards() {
      this.formSubmitting = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/transfer_in/' +
          this.transferInData.id +
          '/receive?origin_site_id=' +
          secureStorage.getItem('currentSiteId')
      );

      if (response.id) {
        this.closeDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been received.',
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Something went wrong. Please try again.',
          placement: 'topLeft',
        });
      }

      this.formSubmitting = false;
      this.closeDrawer;
    },

    async partialReceiveCards() {
      this.formSubmitting = true;

      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/transfer_in/' +
          this.transferInData.id +
          '/partial_receive?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        {
          transfer_in: {
            cards: this.cards,
          },
        }
      );

      if (response.id) {
        this.closeDrawer();
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been received.',
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Something went wrong. Please try again.',
          placement: 'topLeft',
        });
      }

      this.formSubmitting = false;
      this.closeDrawer;
    },

    populateCardRange(from, to) {
      for (let i = from; i <= to; i++) {
        this.cards.push(i);
      }
    },

    onChange() {
      this.cards = [];
      this.cardsFull = [];
      this.cardNumberFrom = null;
      this.cardNumberTo = null;
      this.cardNumber = null;
    },

    clearForm() {
      this.receiveBy = 'batch';
      this.cards = [];
      this.cardsFull = [];
      this.cardNumberFrom = null;
      this.cardNumberTo = null;
      this.cardNumber = null;
      this.transferCardNumberFrom = null;
      this.transferCardNumberTo = null;
      this.cardRange = [];
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },

    setFormData(data = null) {
      if (data !== null) {
        const { cards } = data;

        this.transferCardNumberFrom = cards[0].card_number;
        this.transferCardNumberTo = cards[cards.length - 1].card_number;
      } else {
        this.clearForm();
      }
    },

    async validateCards(card_number, transfer_id) {
      this.activating = true;
      const response = await HTTPRequest.getRequest(
        '/api/v1/cards/validateCardForTransferIn/' +
          card_number +
          '?transfer=' +
          transfer_id
      );

      if (response.id) {
        // this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card is valid',
        });

        this.cards.push(this.cardNumber);
        this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x));
        this.cardsFull.push({card_number: response.card_number, serial_no: response.serial_no, card_type_name: response.cardType.name})
        this.cardsFull = _.uniqWith(this.cardsFull, _.isEqual);
        // this.cardsFull = this.cardsFull.filter((x, i) => i === this.cardsFull.indexOf(x));
        this.cardNumber = null;
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Card is invalid.',
        });
      }
      this.activating = false;
    },

    async validateRange(from, to) {
      this.activating = true;
      const response = await HTTPRequest.postRequest(
        '/api/v1/cards/validateCardRangeForTransferIn/',
        {
          from: from,
          to: to,
          card_transfer_id: this.transferInData.id,
        }
      );

      if (response.length > 0) {
        // this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description:
            'Serial Range is valid. Valid card count: ' + response.length,
        });

        for (var i = 0; i < response.length; i++) {
          this.cards.push(response[i].card_number);
          this.cards = this.cards.filter((x, i) => i === this.cards.indexOf(x));
        }
        this.cardNumberFrom = null;
        this.cardNumberTo = null;
        this.cardRange.push({
          key: this.cardRange.length + 1,
          from: from,
          to: to,
          count: response.length,
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Serial Range is invalid.',
        });
      }
      this.activating = false;
    },
  },
  async mounted() {
    this.setFormData(this.transferInData);
    // Process Full Card List
    this.cardListGrouped = _.groupBy(this.transferInData.fullCardDetails, card => card.card_status_name);
  },
  watch: {
    transferInData: function (data) {
      this.setFormData(data);
    },
  },
};
</script>

<style>
.table-striped-2 {
  background-color: #fafafa;
}
</style>
